/**
 * DatabaseOspiti Page - Page Shell
 * Imports GuestDatabase from features/guests
 * Data fetched via React Query hooks
 */

import { GuestDatabase } from "@/features/ospiti";

export default function DatabaseOspiti() {
  return <GuestDatabase />;
}
